import type { ComponentType, SVGProps } from 'react';
import {
  DocumentIcon,
  SaveIcon,
  CheckIcon,
  PrintIcon,
  DuplicateIcon,
  XIcon,
  PlusIcon,
  PurchasesIcon,
  SalesIcon,
  InventoryIcon,
} from '../icons';

export type IconComponent = ComponentType<SVGProps<SVGSVGElement>>;

export const DEFAULT_ICON_REGISTRY: Record<string, IconComponent> = {
  document: DocumentIcon,
  save: SaveIcon,
  check: CheckIcon,
  print: PrintIcon,
  duplicate: DuplicateIcon,
  x: XIcon,
  close: XIcon,
  plus: PlusIcon,
  purchases: PurchasesIcon,
  sales: SalesIcon,
  inventory: InventoryIcon,
};
